import Details from "components/general/Details";
import React, { Fragment, createContext } from "react";
import useEmailParameters from "../EmailParameters/useEmailParameters";
import { Spinner } from "components/individual/Spinner/Spinner";
import CommentBox from "components/individual/CommentBox";
import Update from "./Update";
import AutocompleteEmail from "components/individual/AutocompleteEmail";

/**
 * @type {import("react").Context<import("../EmailParameters/useEmailParameters/types").ReturnUseEmailParameters|undefined>}
 */
export const ContextReminderPayments = createContext(undefined);

export default function EmailInvoiceEmited() {
  const hook = useEmailParameters({
    module: "facturaEmitida",
  });

  if (hook.isLoading)
    return <Spinner text={"Cargando plantilla"} hidden={false} />;

  return (
    <ContextReminderPayments.Provider value={hook}>
      <Details summary="Factura emitida" open>
        <Fragment>
          <b>TO</b>
          <p>
            1. Correo del cliente al que se hizo la factura
          </p>
          
          <br />
          <b>CC</b>
          <p>1. Ejecutivo que generó el pedido</p>
          <p>2. Ejecutivo que esta efectuando el timbre del pedido</p>
          <p>3. Contacto asociado al pedido (si es que tiene)</p>
          <p>4. Contactos asociados al cliente que esten marcado como "Contacto de cobranza"</p>
          <p>5. Correos atachados en el campo de abajo</p>
        </Fragment>

        <AutocompleteEmail
          aditionalEmails={hook.cc}
          onChange={(emails) => hook.setCc(emails)}
          label="Correos con copia"
        />
        <br />

        <b>Cuerpo del correo</b>
        <CommentBox
          value={hook.body}
          type="facturaEmitida"
          onChange={(content) => hook.setBody(content)}
        />

        <Update />
      </Details>
    </ContextReminderPayments.Provider>
  );
}
